/**
 * Created by Shiv Roy on 21/12/17.
 */
import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  createSearchUrlForCustomAPI,
  createSearchUrlScheduling,
  extractDataFromObject,
  extractNameFromArray,
  jsonApiHeader,
  showSuccessMessage,
  downloadFilesOnAPICallForCCDA,
} from '../../../../../actions/utilAction';

export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  createSearchUrlForCustomAPI,
  createSearchUrlScheduling,
  create_post_data,
  showSuccessMessage,
  extractDataFromObject,
  extractNameFromArray,
  API_URL,
  downloadFilesOnAPICallForCCDA,
};

export const PATIENT_DETAIL = `${API_URL}/patients/GetPatientsDetails`;
// export const PATIENT_API = `${API_URL}/patient`;
export const PATIENT_IMMUNIZATION_API = `${API_URL}/PatientsImmunization/GetImmunization`;
export const PATIENT_MEDICATION_API = `${API_URL}/PatientsMedication/GetMedication`;
export const PATIENT_LABS_API = `${API_URL}/patient-lab-test`;
// export const PATIENT_APPOINTMENT_API = `${API_URL}/api/PatientAppointments/GetPatientAppointmentList`;
export const PATIENT_APPOINTMENT_API = `${API_URL}/api/PatientAppointments/GetPatientAppointmentListForPatientPortal`;
export const PATIENT_ALLERGY_API = `${API_URL}/PatientsAllergy/GetAllergies`;
export const GET_PATIENT_INSURANCE_API = `${API_URL}/PatientsInsurance/GetPatientInsurances`;
export const PATIENT_AUTHORIZATION_API = `${API_URL}/Authorizations/GetAllAuthorizationsForPatient`;
export const PATIENT_FAMILY_HISTORY_API = `${API_URL}/PatientMedicalFamilyHistory/GetPatientMedicalFamilyHistoryById`;
export const GET_OFFICE_HOURS_API = `${API_URL}/MasterLocations/GetMinMaxOfficeTime`;
export const PATIENT_ENCOUNTER_API = `${API_URL}/patient-encounter/GetPatientEncounterDetails`;
export const SAVE_SOAP_API = `${API_URL}/patient-encounter/SavePatientEncounter`;
export const GET_APPOINTMENT_DATA_API = `${API_URL}/api/PatientAppointments/GetAppointmentDetails`; // Video call
export const PATIENT_NONBILLABLE_ENCOUNTERS_DETAILS_API = `${API_URL}/patient-encounter/GetPatientNonBillableEncounterDetails`;
export const POST_ENCOUNTER_SIGNS_API = `${API_URL}/patient-encounter/SaveEncounterSignatureFromParentPortal`;
export const Claim_API = `${API_URL}/Claim/CreateClaimFromParentPortal`;

export const patientActionTypes = {
  get_patient_details: createRequestActionTypes('GET_PATIENT_DETAILS_FOR_PATIENTPORTAL'),
  get_patient_immunization: createRequestActionTypes('GET_PATIENT_IMMUNIZATION_FOR_PATIENTPORTAL'),
  get_patient_medication: createRequestActionTypes('GET_PATIENT_MEDICATION_FOR_PATIENTPORTAL'),
  get_patient_labs: createRequestActionTypes('GET_PATIENT_LABS_FOR_PATIENTPORTAL'),
  get_patient_appointment: createRequestActionTypes('GET_PATIENT_APPOINTMENT_FOR_PATIENTPORTAL'),
  get_patient_allergy: createRequestActionTypes('GET_PATIENT_ALLERGY_FOR_PATIENTPORTAL'),
  get_patient_insurance: createRequestActionTypes('GET_PATIENT_INSURANCE_FOR_PATIENTPORTAL'),
  get_patient_authorization: createRequestActionTypes('GET_PATIENT_AUTHORIZATION_FOR_PATIENTPORTAL'),
  get_patient_family_history: createRequestActionTypes('GET_PATIENT_FAMILY_HISTORY_FOR_PATIENTPORTAL'),
  get_office_hours: createRequestActionTypes('GET_SCHEDULING_OFFICE_HOURS_FOR_PATIENTPORTAL'),
  get_patient_single_encounter: createRequestActionTypes('GET_PATIENT_ENCOUNTER_FOR_PATIENTPORTAL'),
  post_patient_soap: createRequestActionTypes('SAVE_PATIENT_ENCOUNTER_FOR_PATIENTPORTAL'),
  get_appointment_by_id: createRequestActionTypes('GET_APPOINTMENT_DATA_FOR_PATIENTPORTAL'),
  get_patient_encounter_nonBillable: createRequestActionTypes('NON_BILLABLE_GET_PATIENT_ENCOUNTER_FOR_PATIENTPORTAL'),
  post_EncounterSigns: createRequestActionTypes('POST_ENCOUNTERSIGNS'),
  create_claim: createRequestActionTypes('CREATE_CLAIM_BYENCOUNTERID'),
};



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/details/constants/ApiConstants.js